import { ArrowRight } from 'lucide-react';
import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { QUOTE_REQUEST_PATH, STORE_PATH } from '@/shared/config';

/**
 * 회사 소개 마무리 — 연한 회색 판에 큰 문구와 두 갈래 버튼.
 * 스토어에서 상품을 골라 디자인을 시작하거나, 견적문의로 바로 상담을 남긴다.
 */
export const AboutCta = (): ReactElement => (
  <section
    aria-labelledby="about-cta-heading"
    className="flex flex-col gap-10 bg-muted/70 px-6 py-14 sm:px-12 sm:py-20 lg:flex-row lg:items-end lg:justify-between"
  >
    <div className="flex flex-col gap-4">
      <span aria-hidden className="block h-1 w-12 bg-brand-lime" />
      <h2
        id="about-cta-heading"
        className="text-[clamp(1.75rem,3.4vw,3rem)] leading-[1.2] font-bold tracking-[-0.03em] text-balance"
      >
        지금 바로 디자인해 보세요
      </h2>
      <p className="text-[15px] text-muted-foreground sm:text-base">
        상품을 고르고 디자인하면 수량별 예상 금액을 바로 확인할 수 있습니다.
      </p>
    </div>

    <div className="flex flex-col gap-3 sm:flex-row">
      <Link
        to={STORE_PATH}
        className="inline-flex h-13 items-center justify-center gap-2 rounded-full bg-primary px-7 text-[15px] font-semibold text-primary-foreground transition-opacity hover:opacity-90"
      >
        디자인 시작하기
        <ArrowRight aria-hidden strokeWidth={1.75} className="size-4" />
      </Link>
      <Link
        to={QUOTE_REQUEST_PATH}
        className="inline-flex h-13 items-center justify-center rounded-full border border-foreground px-7 text-[15px] font-semibold transition-colors hover:bg-foreground hover:text-background"
      >
        견적 문의
      </Link>
    </div>
  </section>
);
